<template>
    <div class="logos">
        <a target="_blank" href="https://tsu.ru">
            <img v-bind:height="heightSize + 'px' " class="logo" src="../assets/img/logos/tsu_logo_basic_sign.svg" alt="tsu">
        </a>
        <a target="_blank" href="http://opendata.university/">
            <img v-bind:height="heightSize + 'px' " class="logo" src="../assets/img/logos/oduc.png" alt="oduc">
        </a>
    </div>
</template>

<script>
export default {
  name: "Logos",
  props: {
    heightSize: {
      type: Number,
      default: 80
    }
  }
}
</script>

<style scoped lang="sass">
    .logos
        margin-top: gridSteps(0)
        justify-content: space-around
        flex-shrink: 0
        display: flex

</style>
